import React, { useState ,useEffect} from "react";
import {
  AppBar,
  Box,
  Toolbar,
  IconButton,
  Tooltip,
  Typography,
  Button
} from "@mui/material";

import HomeIcon from "@mui/icons-material/Home";
import LogoutIcon from "@mui/icons-material/Logout";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import HelpIcon from '@mui/icons-material/Help';

import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useLocation } from 'react-router-dom';

import { create } from "../../Store/projectPermission/permssionReducer";

import Projectcolors from "../../Utils/Colors";

import optimizelogo from "../../images/logooptimizegsfinal.png";
import gpticon from "../../images/gpticon.png";
import selexsuite from "../../images/SelexSuite.png";
import SelexMBlogo from "../../images/SelexMB Final.png";
import selexsim from "../../images/SelexSIM.png";


const navy = "#061d34";


function AdminNavbar(props) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [isLoggedIn, setIsLoggedIn] = useState(
  !!sessionStorage.getItem("adminlogin")
);
const selexMBRoutes = ["/home", "/newproject", "/help"];

const selexSimRoutes = [
  "/selexsim",
  "/selexsimlanding",
  "/selexsim-help",
];
 const currentLogo = selexMBRoutes.includes(location.pathname)
  ? {
      href: "/select",
      logo: SelexMBlogo,
      alt: "SelexMB Logo",
    }
  : selexSimRoutes.includes(location.pathname)
  ? {
      href: "/selectselexsim",
      logo: selexsim,
      alt: "SelexSim Logo",
    }
  : {
      href: "/select",
      logo: optimizelogo,
      alt: "Optimize Logo",
    };


  function logout() {
    sessionStorage.removeItem("usertoken");
    sessionStorage.removeItem("projectID");
    sessionStorage.removeItem("projectName");

    dispatch(create([{ empty: true }]));

      navigate("/admin");
    
  }
  console.log(props)


  return (
    <Box sx={{ pb: "92px" }}>
      <AppBar
        elevation={0}
        sx={{
          position: "fixed",
          top: 0,
          left: "50%",
          transform: "translateX(-50%)",
          width: "calc(100% - 40px)",
          maxWidth: "2400px",
          height: 78,
          borderRadius: "24px",
          background: "#fff",
          backdropFilter: "blur(18px)",
          border: "1px solid rgba(255,255,255,0.45)",
          boxShadow: "0 14px 45px rgba(0,0,0,0.10)",
          zIndex: 9999,
        }}
      >
        <Toolbar
          sx={{
            height: "78px",
            minHeight: "78px !important",
            px: { xs: 2, md: 3 },
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {/* LEFT LOGO + HOME */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>

        <Box
  component="a"
  href={currentLogo.href}
  sx={{
    display: "flex",
    alignItems: "center",
    textDecoration: "none",
  }}
>
  <Box
    component="img"
    src={currentLogo.logo}
    alt={currentLogo.alt}
    sx={{
      height: 54,
      width: 150,
      objectFit: "contain",
    }}
  />
</Box>

          

           

           
        


          {location.pathname == "/adminhome" ?(

            <Tooltip title={<Typography fontSize={14}>Home</Typography>}>
              <IconButton
                href="/admin"
                sx={{
                  width: 42,
                  height: 42,
                  borderRadius: "14px",
                  background: "rgba(0,120,201,0.08)",
                  color: Projectcolors.primary || "#0078c9",
                  transition: "0.3s",
                  "&:hover": {
                    background: "#9e0b22",
                    color: "#fff",
                    transform: "translateY(-2px)",
                  },
                }}
              >
                <HomeIcon sx={{ fontSize: 24 }} />
              </IconButton>
            </Tooltip>
          ):( <Tooltip title={<Typography fontSize={14}>Home</Typography>}>
              <IconButton
                href="/"
                sx={{
                  width: 42,
                  height: 42,
                  borderRadius: "14px",
                  background: "rgba(0,120,201,0.08)",
                  color: Projectcolors.primary || "#0078c9",
                  transition: "0.3s",
                  "&:hover": {
                    background: "#9e0b22",
                    color: "#fff",
                    transform: "translateY(-2px)",
                  },
                }}
              >
                <HomeIcon sx={{ fontSize: 24 }} />
              </IconButton>
            </Tooltip>)}

          </Box>
          

          {/* CENTER LOGO */}
          <Box
            component="a"
            href="/select"
            sx={{
              position: "absolute",
              left: "50%",
              transform: "translateX(-50%)",
              display: { xs: "none", sm: "flex" },
              alignItems: "center",
              justifyContent: "center",
              textDecoration: "none",
            }}
          >
            <Box
              component="img"
              src={selexsuite}
              alt="SelexSuite"
              sx={{
                height: 150,
                width: 250,
                objectFit: "contain",
              }}
            />
          </Box>

          {/* RIGHT ACTIONS */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.2 }}>
            
          

                {isLoggedIn? (
            <Tooltip title={<Typography fontSize={14}>Logout</Typography>}>
              <IconButton
                onClick={logout}
                sx={{
                  width: 44,
                  height: 44,
                  borderRadius: "14px",
                  background: "rgba(0,120,201,0.08)",
                  color: "#0078c9",
                  transition: "0.3s",
                  "&:hover": {
                    background: "#9e0b22",
                    color: "#fff",
                    transform: "translateY(-2px)",
                  },
                }}
              >
                <LogoutIcon sx={{ fontSize: 23 }} />
              </IconButton>
            </Tooltip> ):
            ( <Tooltip title={<Typography fontSize={14}>Login </Typography>}>
  <Button
    href="/admin"
    sx={{
      width: 140,
      height: 44,
      borderRadius: "14px",
      background: "linear-gradient(135deg, #005da0, #005da0)",
      color: "#fff",
      transition: "0.3s",
      textTransform: "none",
      fontWeight: 700,
      fontSize:14,

      "&:hover": {
        background: "#9e0b22",
        color: "#fff",
        transform: "translateY(-2px)",
      },
    }}
  >
    Login or Signup
  </Button>
</Tooltip>)};
          </Box>
        </Toolbar>
      </AppBar>
    </Box>
  );
}

export default AdminNavbar;